<template>
    <div class="contact-banner-wrapper">
        <span class="contact-banner-title">
            <div class="contact-banner-overlay contact-banner-overlay-b"></div>
            <div class="contact-banner-overlay contact-banner-overlay-w"></div>
            <span class="contact-banner-title-element">Avanza ahora al siguiente nivel.</span>
        </span>
        <p class="contact-banner-subtitle">¿Hablamos?</p>
        <router-link @mouseenter.native="animateHover('Será un placer')" @mouseout.native="animateHover('Da un paso al siguiente nivel.')" to="/contact" class="contact-banner-link" title="Contactar">Contactar</router-link>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import gsap, { Power3 } from 'gsap';

    export default Vue.extend({
        name: 'ContactBanner',
        methods: {
            animateHover( changedText = '' ) {
                const tl = gsap.timeline();
                const overlayBElement = document.querySelector('.contact-banner-overlay-b');
                const overlayWElement = document.querySelector('.contact-banner-overlay-w');
                
                tl.to( overlayBElement, .4, {height: '140%', opacity: '1', ease: Power3.easeOut}, 0 );
                tl.to( overlayWElement, .4, {height: '140%', opacity: '1', ease: Power3.easeOut}, '-=.15' );

                tl.add( () =>  this.setTitleText( changedText ) );

                tl.to( overlayBElement, .3, {width: 0, left: '200%', ease: Power3.easeIn}, '>' );
                tl.to( overlayWElement, .3, {width: 0, left: '200%', ease: Power3.easeIn}, '<' );
                
                tl.to( overlayWElement, .1, {width: '110%', left: '-5%' , top: '-30%', height: 0}, '>' );
                tl.to( overlayBElement, .1, {width: '110%', left: '-5%' , top: '-30%', height: 0}, '<' );
            },
            setTitleText( text = '' ) {
                const textElement     = document.querySelector('.contact-banner-title-element') as HTMLSpanElement;
                textElement.innerHTML = text; 
            }
        }
    })
</script>

<style scoped lang="scss">
    .contact-banner {
        &-wrapper {
            min-height: 50vh;
            background-color: #fff;
            padding: 2rem;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
        }

        &-title {
            font-size: 2.2rem;
            font-weight: 600;
            margin-bottom: .4rem;
            position: relative;
        }

        &-overlay {
            position: absolute;
            left: -5%;
            top: -30%;
            width: 110%;
            height: 0%;
            filter: blur(2);
            -webkit-filter: blur(2);
            background: url(../../assets/img/noise.png);


            &-b {
                background: #121315;
                z-index: 1;
            }
            &-w {
                background: rgba(255, 255, 255, 1);
                z-index: 2;
            }
        }

        &-subtitle {
            font-size: 2rem;
            font-weight: 500;
            margin-bottom: 1.5rem;
            color: #8B8B8B;
        }

        &-link {
            font-size: 1.4rem;
            font-weight: 500;
            margin-bottom: 1rem;
            color: #8B8B8B;
            background-color: #121315;
            display: inline-block;
            color: #fff;
            padding: .5rem;
            text-align: center;
            max-width: 180px;
            text-decoration: none;
            box-shadow: 0px 0px 0px #121315;
            transition: all .3s;
            border: 1px solid transparent;
            cursor: pointer;
            clip-path: circle(100% at 50% 50%);
            -webkit-clip-path: circle(100% at 50% 50%);

            &:hover,
            &:focus {
                background-color: transparent;
                border: 1px solid transparent;
                color: #121315;
                clip-path: circle( 60% at 50% 50%);
                -webkit-clip-path: circle( 60% at 50% 50%);
            }
        }
    }
</style>